import type React from 'react';
import { useIsMobileView } from '../../../hooks/useMediaQuery';
import type { ComparableSubscription } from '../../../models/subscription-comparison/ComparableSubscriptions';
import { formatAmount } from '../../../utils/format';
import { FeaturesTable } from './features-table/FeaturesTable';
import { OverviewList } from './overview-list/OverviewList';

import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { campaignRoutes } from '~/components/routes/campaign/campaign.routes';
import { comparisonCategories } from '~/components/routes/choose-subscription/placeholderSubscriptionComparisonData';
import { Button, Icon } from '..';
import { useIsIframe } from '../../../hooks/useIsIframe';
import './subscription-comparison.scss';
import { ViaplayNegotiationsAlert } from '../viaplay-info-alert/ViaplayNegotiationsAlert';
import { SubBody } from '@rikstv/shared-components';

interface Props {
  title: string;
  comparableSubscriptions: ComparableSubscription[];
  partnerAlias: string;
  dwellingUnit: string;
}

const SubscriptionComparison: React.FC<Props> = ({ title, comparableSubscriptions, partnerAlias, dwellingUnit }) => {
  const isMobileView = useIsMobileView();
  const isIframe = useIsIframe();
  const navigate = useNavigate();

  return (
    <>
      <ViaplayNegotiationsAlert matchOverviewListSize />
      {isMobileView && (
        <div style={{ textAlign: 'center' }}>
          <h1 className="title-2">{title}</h1>
        </div>
      )}
      <div className="subscription-comparison">
        <div className="introduction">{!isMobileView && <h1 className="title-2">{title}</h1>}</div>

        <OverviewList
          comparableSubscriptions={comparableSubscriptions}
          partnerAlias={partnerAlias}
          dwellingUnit={dwellingUnit}
          isMobileView={isMobileView}
          isIframe={isIframe}
        />

        {!isMobileView && <FeaturesTable comparableSubscriptions={comparableSubscriptions} comparisonCategories={comparisonCategories} />}

        <ConditionsText comparableSubscriptions={comparableSubscriptions} />
        {!isIframe && location.pathname !== campaignRoutes.index && (
          <Button
            className="back-button"
            type="primary blue"
            iconMargin="right"
            aria-label="Tilbake til start"
            onClick={() => navigate('/')}
          >
            <Icon type="arrow" flip="horizontal" fill="white" size={1.5} />
            Tilbake
          </Button>
        )}
      </div>
    </>
  );
};

const ConditionsText: FC<{comparableSubscriptions: ComparableSubscription[]}> = ({comparableSubscriptions}) => {
    const minPrice = comparableSubscriptions.map((sub) => {
      if (sub.offerPeriodInMonth !== null) {
        return `Min. tot. første 1. år for ${sub.name}: ${formatAmount(
          sub.currentPrice * sub.offerPeriodInMonth + sub.originalPrice * (12 - sub.offerPeriodInMonth),
        )}`;
      }
      return `Min. tot. første 1. år for ${sub.name}: ${formatAmount(sub.currentPrice * 12)}.`;
    }).join(' ');

    return (
      <SubBody as='div' className="conditions">
        *Tilbudet gjelder nye kunder og 12 mnd. avtaleperiode. {minPrice}<br/>
        **TV 2 Play Start, HBO Max Basis og Viaplay Film & Serier inneholder reklameinnslag før og under programmene.
      </SubBody>
    );
  }

export default SubscriptionComparison;
